import React, { useContext, useState } from 'react';
import axios, { AxiosError } from 'axios';
import HeaderDash from '../HeaderDashNew';
import Footer from '../Footer';
import UserAuthContext from '../../../context/UserAuthContext';
import './Profile.css';
import ENDPOINTS from '../../../endpoints';
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";
import profile from '../../../assets/icons/user.png';
import { useNavigate } from 'react-router-dom';

const Profile: React.FC = () => {
  const { userData } = useContext(UserAuthContext);
  const [showModal, setShowModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [isEnabling2FA, setIsEnabling2FA] = useState(false);

  const [showDisable2FAModal, setShowDisable2FAModal] = useState(false);
const [disable2FACode, setDisable2FACode] = useState('');
const [isDisabling2FA, setIsDisabling2FA] = useState(false);
const navigate = useNavigate();

  const [qrCodeData, setQrCodeData] = useState<{ qrCode: string; secret: string } | null>(null);
  const [otpCode, setOtpCode] = useState('');

  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      Toastify({
        text: 'New password and confirm password do not match',
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "top",
        position: "center",
        stopOnFocus: true,
        style: {
          background: "linear-gradient(to right, #FF0000, #CB4335)",
        },
        onClick: function () { }
      }).showToast();
      return;
    }

    try {
      const token = localStorage.getItem('token');

      const response = await axios.post(ENDPOINTS.changePassword, {
        email: userData?.email,
        current_password: currentPassword,
        new_password: newPassword,
      },{
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data.success) {
        setShowModal(false);
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        Toastify({
          text: "Password changed successfully",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "center",
          stopOnFocus: true,
          style: {
            background: "linear-gradient(to right, #00b09b, #96c93d)",
          },
          onClick: function () { }
        }).showToast();
      } else {
        Toastify({
          text: response.data.message || 'Error changing password',
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "center",
          stopOnFocus: true,
          style: {
            background: "linear-gradient(to right, #FF0000, #CB4335)",
          },
          onClick: function () { }
        }).showToast();
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        Toastify({
          text: error.response.data.message || 'Error changing password',
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "center",
          stopOnFocus: true,
          style: {
            background: "linear-gradient(to right, #FF0000, #CB4335)",
          },
          onClick: function () { }
        }).showToast();
      } else {
        Toastify({
          text: 'Error changing password',
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "center",
          stopOnFocus: true,
          style: {
            background: "linear-gradient(to right, #FF0000, #CB4335)",
          },
          onClick: function () { }
        }).showToast();
      }
    }
  };

  return (
    <div className="profile-page full-width">
      <HeaderDash />
      <div className="profile-content container-fluid theme-background">
        <div className="profile-card">
          <div className="profile-image">
            <img src={profile} alt="Profile" />
          </div>
          <div className="profile-details">
            <div className="profile-field">
              <label>Username:</label>
              <input type="text" value={userData?.user_name || ''} readOnly />
            </div>
            <div className="profile-field">
              <label>Email:</label>
              <input type="text" value={userData?.email || ''} readOnly />
            </div>
            <div className="profile-field">
              <label>Email Verified:</label>
              <span>
                {userData?.email_verified ? (
                  <>
                    Verified <i className="fas fa-check-circle verified"></i>
                  </>
                ) : (
                  <>
                    Not Verified <i className="fas fa-times-circle not-verified"></i>
                  </>
                )}
              </span>
            </div>
            <div className="profile-field">
              <label>Wallet Address:</label>
              <input type="text" value={userData?.wallet_address || ''} readOnly />
            </div>
            <div className="profile-field">
              <label>Referrer Username:</label>
              <input type="text" value={userData?.sponsor_name || ''} readOnly />
            </div>
            {/* <div className="profile-field">
              <label>Referrer Address:</label>
              <input type="text" value={userData?.sponsor_details?.sponsor_wallet_address || ''} readOnly />
            </div> */}
            <div className="profile-field">
              <label>Rainmaker Level:</label>
              <input type="text" value={userData?.rainmaker_level || ''} readOnly />
            </div>
            <div className="profile-field">
              <label>Premium Level:</label>
              <input type="text" value={userData?.premium_level || ''} readOnly />
            </div>
            <div className="profile-field">
              <label>Commission Earnings:</label>
              <input type="text" value={`$${userData?.payout_wallet || '0.00'}`} readOnly />
            </div>
            <div className="profile-field" id="security">
              <label>Two-Factor Authentication (2FA):</label>
              {userData?.isTwoFactorEnabled ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span>
                    Enabled <i className="fas fa-check-circle verified"></i>
                  </span>
                  <button
  className="disable-2fa-btn"
  onClick={() => setShowDisable2FAModal(true)}
>
  Disable 2FA
</button>
                </div>
              ) : (
                <button
                  className="enable-2fa-btn"
                  onClick={async () => {
                    try {
                      setIsEnabling2FA(true);
                      const token = localStorage.getItem('token');
                      const response = await axios.post(
                        ENDPOINTS.enable2FA,
                        {},
                        {
                          headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                          },
                        }
                      );
                      if (response.data.status === true) {
                        setQrCodeData({ qrCode: response.data.qrCode, secret: response.data.secret });
                        Toastify({
                          text: '2FA Enabled. Continue setup...',
                          duration: 2000,
                          close: true,
                          gravity: 'top',
                          position: 'center',
                          backgroundColor: 'linear-gradient(to right, #00b09b, #96c93d)',
                        }).showToast();
                        setShow2FAModal(true);
                      } else {
                        throw new Error(response.data.message || 'Failed to enable 2FA');
                      }
                    } catch (error) {
                      Toastify({
                        text: 'Error enabling 2FA',
                        duration: 3000,
                        close: true,
                        gravity: 'top',
                        position: 'center',
                        backgroundColor: 'linear-gradient(to right, #FF0000, #CB4335)',
                      }).showToast();
                    } finally {
                      setIsEnabling2FA(false);
                    }
                  }}
                  disabled={isEnabling2FA}
                >
                  {isEnabling2FA ? 'Enabling...' : 'Enable 2FA'}
                </button>
              )}
            </div>
          </div>
          <div role="form">
            <div className="password-section">
              <hr />
              <div className="profile-field">
                <label>Password:</label>
                <input type="password" value="********" readOnly />
                <button className="btn btn-secondary" onClick={() => setShowModal(true)}>Change Password</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {showModal && (
        <div className="change-password-modal">
          <div className="modal-content">
            <span className="close" onClick={() => setShowModal(false)}>&times;</span>
            <h2 className="modal-heading">Change Password</h2>
            <div className="modal-field">
              <label>Current Password:</label>
              <div className="password-input">
                <input
                  type={showCurrentPassword ? "text" : "password"}
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <i
                  className={`fas ${showCurrentPassword ? "fa-eye-slash" : "fa-eye"}`}
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                ></i>
              </div>
            </div>
            <div className="modal-field">
              <label>New Password:</label>
              <div className="password-input">
                <input
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <i
                  className={`fas ${showNewPassword ? "fa-eye-slash" : "fa-eye"}`}
                  onClick={() => setShowNewPassword(!showNewPassword)}
                ></i>
              </div>
            </div>
            <div className="modal-field">
              <label>Confirm New Password:</label>
              <div className="password-input">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <i
                  className={`fas ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                ></i>
              </div>
            </div>
            <button className="btn btn-primary" onClick={handleChangePassword}>Submit</button>
          </div>
        </div>
      )}

      {show2FAModal && qrCodeData && (
        <div className="change-password-modal">
          <div className="modal-content">
            <span className="close" onClick={() => setShow2FAModal(false)}>&times;</span>
            <h2 className="modal-heading">Set Up Two-Factor Authentication</h2>
            <img src={qrCodeData.qrCode} alt="2FA QR Code" className="qr-image" />
            <p style={{ textAlign: 'center', color: '#bbb', fontSize: '13px', marginTop: '-10px', marginBottom: '20px' }}>
  Scan this QR code with your authenticator app
</p>
            <p>
              Secret: <strong>{qrCodeData.secret}</strong>
            </p>
            <div className="modal-field">
              <label htmlFor="otp">Enter the 6-digit code from your Authenticator App:</label>
              <input
                type="text"
                id="otp"
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value)}
                placeholder="123456"
              />
            </div>
            <button
              className="btn btn-primary"
              onClick={async () => {
                try {
                  const token = localStorage.getItem('token');
                  const verifyRes = await axios.post(
                    ENDPOINTS.verify2FA,
                    { token: otpCode },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                      },
                    }
                  );
                  if (verifyRes.data.status === true) {

                          navigate('/dashboard')
                    Toastify({
                      text: '2FA Verified Successfully!',
                      duration: 3000,
                      close: true,
                      gravity: 'top',
                      position: 'center',
                      backgroundColor: 'linear-gradient(to right, #00b09b, #96c93d)',
                    }).showToast();
                    setShow2FAModal(false);
                    setQrCodeData(null);
                    setOtpCode('');
                  } else {
                    throw new Error('Invalid verification code');
                  }
                } catch (err) {
                  Toastify({
                    text: 'Failed to verify 2FA. Please try again.',
                    duration: 3000,
                    close: true,
                    gravity: 'top',
                    position: 'center',
                    backgroundColor: 'linear-gradient(to right, #FF0000, #CB4335)',
                  }).showToast();
                }
              }}
            >
              Verify
            </button>
          </div>
        </div>
      )}
      {showDisable2FAModal && (
  <div className="change-password-modal">
    <div className="modal-content">
      <span className="close" onClick={() => setShowDisable2FAModal(false)}>&times;</span>
      <h2 className="modal-heading">Confirm Disable Two-Factor Authentication</h2>
      <p>Please enter your current 2FA code to confirm disabling.</p>
      <div className="modal-field">
        <label htmlFor="disable2fa-code">2FA Code:</label>
        <input
          id="disable2fa-code"
          type="text"
          value={disable2FACode}
          onChange={e => setDisable2FACode(e.target.value)}
          placeholder="123456"
          maxLength={6}
        />
      </div>
      <button
        className="btn btn-primary"
        disabled={isDisabling2FA}
        onClick={async () => {
          try {
            setIsDisabling2FA(true);
            const token = localStorage.getItem('token');
            
            // Verify the 2FA code first
            const verifyResponse = await axios.post(
              ENDPOINTS.verify2FA,
              { token: disable2FACode },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
              }
            );

            if (verifyResponse.data.status !== true) {
              throw new Error('Invalid 2FA code.');
            }

            // If verified, call disable API
            const disableResponse = await axios.post(
              ENDPOINTS.disable2FA,
              {},
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
              }
            );

            if (disableResponse.data.status === true) {
              Toastify({
                text: '2FA Disabled Successfully',
                duration: 3000,
                close: true,
                gravity: 'top',
                position: 'center',
                backgroundColor: 'linear-gradient(to right, #f44336, #e57373)',
              }).showToast();
              setShowDisable2FAModal(false);
              setDisable2FACode('');
              
                          navigate('/dashboard')
            } else {
              throw new Error('Failed to disable 2FA.');
            }
          } catch (error) {
            Toastify({
              text: 'Error disabling 2FA',
              duration: 3000,
              close: true,
              gravity: 'top',
              position: 'center',
              backgroundColor: 'linear-gradient(to right, #FF0000, #CB4335)',
            }).showToast();
          } finally {
            setIsDisabling2FA(false);
          }
        }}
      >
        Confirm Disable
      </button>
    </div>
  </div>
)}
    </div>
  );
};

export default Profile;
